// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "result": {
      "column": {
        "default": null,
        "name": "result",
        "null": false,
        "type": "string"
      },
      "name": "result",
      "selected_by_default": null,
      "translated": null
    },
    "blank_votes_count": {
      "column": {
        "default": 0,
        "name": "blank_votes_count",
        "null": false,
        "type": "integer"
      },
      "name": "blank_votes_count",
      "selected_by_default": null,
      "translated": null
    },
    "no_votes_count": {
      "column": {
        "default": 0,
        "name": "no_votes_count",
        "null": false,
        "type": "integer"
      },
      "name": "no_votes_count",
      "selected_by_default": null,
      "translated": null
    },
    "yes_votes_count": {
      "column": {
        "default": 0,
        "name": "yes_votes_count",
        "null": false,
        "type": "integer"
      },
      "name": "yes_votes_count",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ProposalVoteResult",
  "collectionKey": "proposal_vote_results",
  "collectionName": "proposal_vote_results",
  "i18nKey": "proposal_vote_result",
  "camelizedLower": "proposalVoteResult",
  "name": "ProposalVoteResult",
  "nameDasherized": "proposal-vote-result",
  "pluralName": "proposal_vote_results",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Proposal",
      "collectionName": "proposals",
      "foreignKey": "proposal_id",
      "name": "proposal",
      "macro": "belongs_to",
      "resource_name": "Proposal",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "blank_votes_count",
      "column": {
        "default": 0,
        "name": "blank_votes_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "no_votes_count",
      "column": {
        "default": 0,
        "name": "no_votes_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "proposal_id",
      "column": {
        "default": null,
        "name": "proposal_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "result",
      "column": {
        "default": null,
        "name": "result",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "yes_votes_count",
      "column": {
        "default": 0,
        "name": "yes_votes_count",
        "null": false,
        "type": "integer"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "proposal_vote_result",
  "primaryKey": "id"
}

/** Frontend model for ProposalVoteResult. */
export default class ProposalVoteResult extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  result() {
    return this.readAttributeUnderscore("result")
  }

  /** @returns {boolean} */
  hasResult() {
    const value = this.result()

    return this._isPresent(value)
  }

  /** @returns {number} */
  blankVotesCount() {
    return this.readAttributeUnderscore("blank_votes_count")
  }

  /** @returns {boolean} */
  hasBlankVotesCount() {
    const value = this.blankVotesCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  noVotesCount() {
    return this.readAttributeUnderscore("no_votes_count")
  }

  /** @returns {boolean} */
  hasNoVotesCount() {
    const value = this.noVotesCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  yesVotesCount() {
    return this.readAttributeUnderscore("yes_votes_count")
  }

  /** @returns {boolean} */
  hasYesVotesCount() {
    const value = this.yesVotesCount()

    return this._isPresent(value)
  }
}
